import React, { FC } from "react";
import { Control, ControllerFieldState, useController } from "react-hook-form";

import RadioBase, { RadioProps } from "@/components/ui/Form/Radio/RadioBase";

export interface InputControlledProps extends RadioProps {
  control: Control;
}
const InputControlled: FC<InputControlledProps> = ({ control, ...rest }) => {
  const { name } = rest;
  const { field, fieldState } = useController({ control, name });
  return <RadioBase field={field} fieldState={fieldState} {...rest} />;
};
export default InputControlled;
